import React from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import { Link } from 'react-router-dom';
import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import ArrowBack from '@material-ui/icons/ArrowBack';
import { FormattedMessage } from 'react-intl';
import Main from 'components/templates/Main';
import { Input } from 'components/FormInputs';
import PATHS from 'constants/paths';

const RenderForm = ({
  values,
  errors,
  isSubmitting,
  isValid,
  handleChange,
  handleSubmit,
  dirty,
}) => (
  <form onSubmit={handleSubmit} autoComplete="new-password">
    <Input
      name="old_password"
      onChange={handleChange}
      errors={errors}
      value={values.old_password}
      type="password"
      label={<FormattedMessage id="changepwd.oldpassword" defaultMessage="Current password" />}
      autoComplete="new-password"
    />
    <Input
      name="password"
      onChange={handleChange}
      errors={errors}
      value={values.password}
      type="password"
      label={<FormattedMessage id="changepwd.newpassword" defaultMessage="New password" />}
    />
    <Input
      name="password_confirm"
      onChange={handleChange}
      errors={errors}
      value={values.password_confirm}
      type="password"
      label={
        <FormattedMessage id="changepwd.confirmpassword" defaultMessage="Confirm new password" />
      }
    />
    <Button
      type="submit"
      fullWidth
      variant="contained"
      color="primary"
      disabled={!isValid || isSubmitting || !dirty}
    >
      <FormattedMessage id="userform.changePassword" defaultMessage="Change password" />
    </Button>
  </form>
);

RenderForm.propTypes = {
  values: PropTypes.shape({
    old_password: PropTypes.string,
    password: PropTypes.string,
    password_confirm: PropTypes.string,
  }),
  errors: PropTypes.shape({}),
  isSubmitting: PropTypes.bool,
  isValid: PropTypes.bool,
  handleChange: PropTypes.func,
  handleSubmit: PropTypes.func,
  dirty: PropTypes.bool,
};

const ChangePassword = ({ onSubmit, intl }) => {
  return (
    <Main
      title={
        <div>
          <IconButton color="inherit" component={Link} to={PATHS.users.profile}>
            <ArrowBack />
          </IconButton>
          <FormattedMessage id="userform.changePassword" defaultMessage="Change password" />
        </div>
      }
    >
      <Box boxShadow={3} p={2}>
        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={12} sm={6} md={4}>
            <Formik
              initialValues={{
                old_password: '',
                password: '',
                password_confirm: '',
              }}
              validateOnChange
              validate={(values) => {
                const err = {};

                ['old_password', 'password', 'password_confirm'].forEach((f) => {
                  if (!values[f]) {
                    err[f] = intl.formatMessage({
                      id: 'Required',
                      defaultMessage: 'Required',
                    });
                  }

                  if (values[f] && values[f].length < 6) {
                    err[f] = intl.formatMessage({
                      id: 'userForm.min6CharsPassword',
                      defaultMessage: 'Password should have at least 6 characters',
                    });
                  }
                });

                if (
                  values.password_confirm &&
                  values.password &&
                  values.password_confirm !== values.password
                ) {
                  err.password_confirm = intl.formatMessage({
                    id: 'userForm.passwordMismatch',
                    defaultMessage: "Password doesn't match",
                  });
                }

                return err;
              }}
              enableReinitialize
              onSubmit={async (values, { setSubmitting }) => {
                try {
                  setSubmitting(true);

                  await onSubmit(values);
                } catch (err) {
                  setSubmitting(false);
                }
              }}
            >
              {(fp) => <RenderForm {...fp} />}
            </Formik>
          </Grid>
        </Grid>
      </Box>
    </Main>
  );
};

ChangePassword.propTypes = {
  intl: PropTypes.shape({ formatMessage: PropTypes.func }),
  onSubmit: PropTypes.func,
};

export default ChangePassword;
